import { userPermissionsSelector } from 'state/slices/session';
import { useSelector } from './store';

export const usePermissions = (): {
  checkRole(roleId: string): boolean
} => {
  const permissions = useSelector(userPermissionsSelector);

  const checkRole = (roleId: string): boolean => {
    const hasRole = permissions
      ?.find((perm) => perm.roles
        .find((role) => role.id === roleId));
    return !!hasRole;
  };

  return {
    checkRole,
  };
};
